import { render } from "./CorrectionReports.vue?vue&type=template&id=2c3435f6&scoped=true"
import script from "./CorrectionReports.vue?vue&type=script&lang=js"
export * from "./CorrectionReports.vue?vue&type=script&lang=js"

import "./CorrectionReports.vue?vue&type=style&index=0&id=2c3435f6&scoped=true&lang=css"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3435f6"]])

export default __exports__